import { ViewSizeValuesPx } from 'bernie-view';

import { DisplayAdDef } from 'models/common/ads-types';

// These values just need to be unique, hence putting everything in one file to avoid collision
export enum AdsenseContainer {
  HSR_FOOTER = 'afs-hsr-container-footer',
  HIS_FOOTER_1 = 'afs-his-container-1',
  HIS_FOOTER_2 = 'afs-his-container-2'
}

// Display ads have arbitrary breakpoints that do not align with bernie
export const DisplayAd: DisplayAdDef = {
  SIDERAIL_XL_R1: {
    uci: 'R1',
    className: 'uitk-grid'
  },
  SIDERAIL_XL_R2: {
    uci: 'R2',
    className: 'uitk-grid sticky-top__with-navbar'
  },
  SIDERAIL_XL_RM: {
    uci: 'RM',
    className: 'uitk-grid'
  },

  HSR_FOOTER_M_CM2: { mediaquery: '(max-width: 751px)', uci: 'CM2' },
  HSR_FOOTER_M_CM1: { mediaquery: '(min-width: 752px)', uci: 'CM1' },
  HSR_FOOTER_L_CM2: { mediaquery: '(max-width: 1041px)', uci: 'CM2' },
  HSR_FOOTER_L_CM1: { mediaquery: '(min-width: 1042px)', uci: 'CM1' },
  HSR_FOOTER_XL_CM2: { mediaquery: '(max-width: 1248px)', uci: 'CM2' },
  HSR_FOOTER_XL_CM1: { mediaquery: '(min-width: 1249px)', uci: 'CM1' },

  HIS_FOOTER_S_CM6: { mediaquery: `(max-width: ${ViewSizeValuesPx.MEDIUM}px)`, uci: 'CM6' },
  HIS_FOOTER_M_CM3: { mediaquery: '(max-width: 751px)', uci: 'CM3' },
  HIS_FOOTER_M_CM2: { mediaquery: '(min-width: 752px)', uci: 'CM2' },
  HIS_FOOTER_L_XL_CM1: { mediaquery: `(min-width: ${ViewSizeValuesPx.LARGE}px)`, uci: 'CM1' }
};
